export enum NotificationResources {
  Account = 'Account',
  User = 'User',
  Title = 'Title',
  Project = 'Project',
  Schedule = 'Schedule',
  Task = 'Task',
  TaskComment = 'TaskComment',
  Milestone = 'Milestone',
  MilestoneComment = 'MilestoneComment',
  Deliverable = 'Deliverable',
  DeliverableComment = 'DeliverableComment',
  Approval = 'Approval',
  ClientApplication = 'ClientApplication',
  PartnerProposal = 'PartnerProposal',
}
